<template>
  <HeaderComponent/>
  <div id="wrapper">
    <MenuComponent/>
    <div style="width: 100%;">
      <h1 class="display-1"
          style="text-align: center; font-size: 46px; font-family: Ubuntu; padding-top: 10px; color: #24509c">Текстовая инструкция</h1>
      <div class="form-check-inline" id="content" style="width: 100%;">
      </div>
    </div>
  </div>
  <FooterComponent/>
</template>

<script>
import HeaderComponent from "@/customer/HeaderComponent";
import MenuComponent from "@/customer/MenuComponent";
import FooterComponent from "@/customer/FooterComponent";
import axios from "axios";

export default {
  name: "CustomerInstructionText",

  components: {HeaderComponent, MenuComponent, FooterComponent},

  data() {
    return {
      instruction: ''
    }
  },

  methods: {
    get_instruction() {
      axios.get("/api/customer/text_instruction").then((response) => {
        let e = document.getElementById("content");
        e.innerHTML = response.data;
      })
    },
  },

  mounted() {
    this.get_instruction()
  }
}
</script>

<style scoped>
#wrapper {
  font-family: Ubuntu;
  display: flex;
  margin-left: 4vw;
  min-height: 85vh;
}
</style>
